export function slugify(text) {
    if(text == null){
        return text
    }
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}
export function getCookie(name) {
    const cookie = document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='));
    return cookie ? cookie.split('=')[1] : null;
}
export function removeCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
export function formatNumber(num = 0) {
    if (typeof num !== 'number') {
        return num; // Return as is if not a number
    }
    return num.toLocaleString();
}
export function truncate(num, decimalPlaces = 2) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.trunc(num * factor) / factor;
}

export function getOrderFlavorText(order, key = "") {
    if (order?.flavors && Array.isArray(order.flavors) && order.flavors.length > 0) {
        return order.flavors
            .filter((f) => (f.qty ?? 1) > 0)
            .map((f) => `${f.name} (${f.qty ?? 1})`)
            .join("، ");
    }
    const orderKey = key || order?.id || "";
    if (typeof orderKey === "string" && orderKey.includes("_f_")) {
        const parts = orderKey.split("_f_")[1];
        if (parts) {
            const tokens = parts.split("_");
            const list = [];
            for (let i = 0; i < tokens.length; i += 2) {
                const name = tokens[i];
                const qty = tokens[i + 1] && !isNaN(tokens[i + 1]) ? parseInt(tokens[i + 1]) : 1;
                if (name) {
                    list.push(`${name} (${qty})`);
                }
            }
            if (list.length > 0) {
                return list.join("، ");
            }
        }
    }
    if (order?.flavorText && typeof order.flavorText === "string" && order.flavorText.trim()) {
        let text = order.flavorText.trim().replace(/\(x(\d+)\)/g, '($1)');
        return text;
    }
    return "";
}

